<template>

  <div class="page_container">

    <div class="text_intro">
        注意：需要升级最新版本（1.3.4及以上）可使用最新功能，部分应用商店新版审核中，请耐心等待。大会员功能将于2015.11.20日调整售价为5000硬币，已购买用户不受影响，感谢支持！
      </div>


    <EquipmentItem :items="items" />




      <!-- <div class="get_yinbi_item_container">
        <div class="get_yinbi_item_left">
            <div class="get_yinbi_item_text_a">PDF导出</div>
            <div class="get_yinbi_item_text_b">未解锁</div>
            
        </div>

        <div class="get_yinbi_item_img">
          <img :src="require('@/assets/pdf_export.png')"  />

        </div>

        
        

      </div>

      <div class="get_yinbi_item_container">
        <div class="get_yinbi_item_left">
            <div class="get_yinbi_item_text_a">云词库</div>
            <div class="get_yinbi_item_text_b">未解锁</div>
            
        </div>

        <div class="get_yinbi_item_img">
          <img :src="require('@/assets/yunciku.png')"  />

        </div>

        
        

      </div>


      <div class="get_yinbi_item_container">
        <div class="get_yinbi_item_left">
            <div class="get_yinbi_item_text_a">终身大会员</div>
            <div class="get_yinbi_item_text_b">未解锁</div>
            
        </div>

        <div class="get_yinbi_item_img">
          <img :src="require('@/assets/member.png')"  />

        </div>

        
        

      </div> -->


  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >

  import EquipmentItem from '@/components/EquipmentItem.vue';


  import { ref, onMounted } from 'vue'

  import { useRouter } from 'vue-router';
  import {getUserEquipmentItems} from '@/api/apiService';

  const router = useRouter();

  const items = ref([])


  onMounted(() => {

    getEquipments()
    
  })




  async function getEquipments() {
  try {
    const response = await getUserEquipmentItems();
    if (response.code === 0 && response.msg === 'success') {
      items.value = response.equipments;
    } else {
      throw new Error('Failed to fetch equipment items');
    }
  } catch (error) {
    
    router.push({ name: 'Wrong' }); // 跳转到错误页面
  }
}

 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    
  }


  .text_intro {
    
    color: #e72222;
    margin-top: 0.1rem;
    margin-left: 0.1rem;
    font-size: 0.4rem;
    text-align: left;
    
    
    
  }
  


  

  






  </style>